/* eslint-disable no-unused-vars */
import 'jquery-validation';
/**
 * Uses JQuery validate for form validation instead of CF7 to allow for dynamic fields
 * @returns {[undefined]} []
 */
export function customValidationInit() {
  const forms = $('[data-js-form-jquery-validate]').parent('form');
  let Validator;
  const errorMessage = 'We need this detail, please!';
  const errorYesNo = "Uh-oh, it looks like you're ineligible.";
  const errorConsent = "Please make sure you have consent before completing this form.";
  const errorNsw = "We're sorry! Our dogs can only go as far as NSW and ACT.";
  const errorNswAct =
    'We\'re sorry! We can only place our pet dogs in NSW and ACT. <a href="https://guidedogs.com.au/about-us/our-dogs/reclassified-dogs">You can learn more about reclassified dogs in other states here.</a>';
  const postcodeEligibilityMessage =
    "Sorry, it looks like you're not eligible based on your postcode.";
  const postcodeEligibilityMessagePr =
    'Unfortunately puppy raising is not currently available in your area. If you would like to discuss further, please email <a href="mailto:puppyraising@guidedogs.com.au">puppyraising@guidedogs.com.au</a>';
  const postcodeEligibilityMessageQLD =
    'Sorry, it looks like you\'re not eligible based on your post code. <a href="https://qld.guidedogs.com.au/get-involved/volunteer/">However they may be other ways you can volunteer.</a>';
  const postcodeErrorMessage = 'Please input a valid postcode.';
  const postcodes = $('[name=valid-postcodes]').val()
    ? $('[name=valid-postcodes]')
        .val()
        .split(',')
        .map((val) => parseInt(val, 10))
    : [];
  const isPuppyRaising =
    $('[name=valid-postcodes]').data('js-for') === 'puppy-raising';

  if (forms.length > 0) {
    for (let f = 0; f < forms.length; f++) {
      constructValidator(forms[f]);
    }
  }

  function constructValidator(form) {
    form = $(form);
    const submitBtn = form.find('[type="submit"]');
    const fields = form.find('.jquery-required');
    const groupFields = form.find('[data-js-group-name]');
    const dateFields = form.find('.jquery-before-today');
    const numberFields = form.find('.jquery-number');
    const uploadFields = form.find('.jquery-upload-limit');
    const genericErrors = form.find('.form__generic-error');
    const genericErrorMessage = forms
      .find('.form__generic-error-message')
      .html();
    const rules = {};
    const messages = {};

    fields.each(function (index) {
      if (this.name === undefined) {
        const key = $(this).find('input')[0].name;

        rules[key] = 'required';
        messages[key] = errorMessage;
      } else if ($(this).hasClass('jquery-email')) {
        rules[this.name] = { required: true, email: true };
        messages[this.name] = {
          required: errorMessage,
          email: 'Please supply a valid email',
        };
      } else if ($(this).hasClass('jquery-before-today')) {
        rules[this.name] = { required: true, maxDate: true };
        messages[this.name] = {
          required: errorMessage,
          maxDate: "The date must be before today's date",
        };
      } else if ($(this).hasClass('jquery-number')) {
        rules[this.name] = { required: true, digits: true };
        messages[this.name] = { required: errorMessage };
      } else if ($(this).hasClass('jquery-postcode')) {
        rules[this.name] = {
          required: true,
          digits: true,
          minlength: 4,
          maxlength: 4,
        };
        messages[this.name] = {
          required: errorMessage,
          digits: postcodeErrorMessage,
          minlength: postcodeErrorMessage,
          maxlength: postcodeErrorMessage,
        };
      } else if ($(this).hasClass('jquery-nsw-only')) {
        rules[this.name] = {
          required: true,
          digits: true,
          minlength: 4,
          maxlength: 4,
          nswPostcode: true,
        };
        messages[this.name] = {
          required: errorMessage,
          digits: postcodeErrorMessage,
          minlength: postcodeErrorMessage,
          maxlength: postcodeErrorMessage,
          nswPostcode: errorNsw,
        };
      } else if ($(this).hasClass('jquery-eligible-postcode')) {
        rules[this.name] = {
          required: true,
          digits: true,
          minlength: 4,
          maxlength: 4,
          eligiblePostcode: true,
        };
        messages[this.name] = {
          required: errorMessage,
          digits: postcodeErrorMessage,
          minlength: postcodeErrorMessage,
          maxlength: postcodeErrorMessage,
          eligiblePostcode: isPuppyRaising
            ? postcodeEligibilityMessagePr
            : postcodeEligibilityMessage,
        };
      } else if ($(this).hasClass('jquery-eligible-postcode-qld')) {
        rules[this.name] = {
          required: true,
          digits: true,
          minlength: 4,
          maxlength: 4,
          eligiblePostcodeQld: true,
        };
        messages[this.name] = {
          required: errorMessage,
          digits: postcodeErrorMessage,
          minlength: postcodeErrorMessage,
          maxlength: postcodeErrorMessage,
          eligiblePostcodeQld: postcodeEligibilityMessageQLD,
        };
      } else if ($(this).hasClass('jquery-not-no')) {
        rules[this.name] = { required: true, mustNotBeNo: true };
        messages[this.name] = {
          required: errorMessage,
          mustNotBeNo: errorYesNo,
        };
      } else if ($(this).hasClass('jquery-consent')) {
        rules[this.name] = { required: true, mustNotBeNo: true };
        messages[this.name] = {
          required: errorMessage,
          mustNotBeNo: errorConsent,
        };
      } else if ($(this).hasClass('jquery-not-yes')) {
        rules[this.name] = { required: true, mustNotBeYes: true };
      } else if ($(this).hasClass('jquery-not-x')) {
        rules[this.name] = { required: true, mustNotBeX: true };
        messages[this.name] = {
          required: errorMessage,
          mustNotBeYes: errorYesNo,
        };
      } else if ($(this).hasClass('jquery-nsw-act')) {
        rules[this.name] = { required: true, nswActOnly: true };
        messages[this.name] = {
          required: errorMessage,
          nswActOnly: errorNswAct,
        };
      } else if ($(this).hasClass('jquery-desexed')) {
        rules[this.name] = { required: true, desexed: true };
        messages[this.name] = { required: errorMessage, desexed: errorYesNo };
      } else {
        rules[this.name] = { required: true };
        messages[this.name] = { required: errorMessage };
      }
    });

    groupFields.each(function (index) {
      if (this.id !== undefined) {
        const selector = this.getAttribute('data-js-group-name');
        const fields = $(this).find('input, select');
        const validationMessage = this.getAttribute(
          'data-js-group-validation-message',
        )
          ? this.getAttribute('data-js-group-validation-message')
          : 'Please provide a valid email or select "Not applicable"';

        for (let f = 0; f < fields.length; f++) {
          if ($(fields[f]).hasClass('jquery-email')) {
            rules[fields[f].name] = {
              validate_group_contact: selector,
              email: true,
            };
            messages[fields[f].name] = {
              validate_group_contact: '',
              email: 'Please supply a valid email',
            };
          } else {
            rules[fields[f].name] = { validate_group_contact: selector };
            if ($(fields[f]).hasClass('jquery-hide-validation')) {
              messages[fields[f].name] = { validate_group_contact: '' };
            } else {
              messages[fields[f].name] = {
                validate_group_contact: validationMessage,
              };
            }
          }
        }
      }
    });

    dateFields.each(function (index) {
      if (!$(this).hasClass('jquery-required')) {
        rules[this.name] = { maxDate: true };
        messages[this.name] = {
          maxDate: "The date must be before today's date",
        };
      }
    });

    numberFields.each(function (index) {
      if (!$(this).hasClass('jquery-required')) {
        rules[this.name] = { digits: true };
      }
    });

    uploadFields.each(function (index) {
      if (this.files) {
        rules[this.name] = { maxUpload: 5 };
      }
    });

    $.validator.addMethod(
      'validate_group_contact',
      (val, element, group) => {
        const groupElements = $(`input${group}, ${group} input`);
        let valid = false;
        for (let i = 0; i < groupElements.length; i++) {
          if (
            (groupElements[i].type === 'checkbox' &&
              groupElements[i].checked) ||
            (groupElements[i].type !== 'checkbox' && groupElements[i].value)
          ) {
            valid = true;
          }
        }
        return valid;
      },
      "Please input a valid entry or select 'Not applicable'",
    );

    $.validator.addMethod(
      'maxDate',
      (value, element) => {
        const curDate = new Date();
        const inputDate = new Date(value);

        if (inputDate < curDate || value === '') {
          return true;
        }
        return false;
      },
      'Invalid Date!',
    );

    $.validator.addMethod(
      'maxUpload',
      (value, element, max) => {
        if (element.files.length) {
          return element.files[0].size < parseInt(max) * 1048576;
        }
        return true;
      },
      'File too large, maximium file size {0}mb.',
    );

    $.validator.addMethod(
      'mustNotBeNo',
      (value, element, max) => value !== 'No',
      errorYesNo,
    );

    $.validator.addMethod(
      'mustNotBeYes',
      (value, element, max) => value !== 'Yes',
      errorYesNo,
    );

    $.validator.addMethod(
      'mustNotBeX',
      (value, element, max) => {
        const $parent = $(element).parents('[data-js-not]');

        if (!$parent.length) {
          return true;
        }

        const disallowedValues = $parent.data('js-not');

        return [...disallowedValues].indexOf(value);
      },
      errorYesNo,
    );

    $.validator.addMethod(
      'desexed',
      (value, element, max) =>
        value !== 'Yes – both entire female/s and male/s',
      errorYesNo,
    );

    $.validator.addMethod(
      'nswActOnly',
      (value, element, max) =>
        value === 'New South Wales' || value === 'Australian Capital Territory',
      errorNswAct,
    );

    $.validator.addMethod(
      'eligiblePostcode',
      (value, element, max) => {
        if (postcodes.length > 0) {
          return postcodes.includes(parseInt(value, 10));
        }
        return true;
      },
      isPuppyRaising
        ? postcodeEligibilityMessagePr
        : postcodeEligibilityMessage,
    );

    $.validator.addMethod(
      'eligiblePostcodeQld',
      (value, element, max) => {
        if (postcodes.length > 0) {
          return postcodes.includes(parseInt(value, 10));
        }
        return true;
      },
      postcodeEligibilityMessageQLD
    );

    $.validator.addMethod(
      'nswPostcode',
      (value, element, max) =>
        parseInt(value, 10) >= 2000 && parseInt(value, 10) < 3000,
      errorNsw,
    );

    Validator = form.validate({
      rules,
      messages,
      focusInvalid: true,
      errorClass: 'form__error',
      errorElement: 'span',
      errorPlacement(error, element) {
        const previousError = element
          .parents('.wpcf7-form-control-wrap')
          .find('span.form__error');
        if (previousError) {
          previousError.remove();
        }

        if (
          element.attr('type') === 'checkbox' ||
          element.attr('type') === 'radio'
        ) {
          error.insertAfter(element.parents('.wpcf7-form-control-wrap'));
        } else {
          error.insertAfter(element);
        }
      },
    });

    if (genericErrors.length > 0) {
      genericErrors.each((index, el) => {
        el.innerHTML = genericErrorMessage;
      });
    }

    // switch in submit button when form is valid.
    submitBtn.on('click', (e) => {
      if (!form.valid()) {
        // Focus on the first invalid element.
        const firstInvalidField = Validator.errorList[0] || null;

        if (
          typeof firstInvalidField === 'object' &&
          firstInvalidField.element
        ) {
          firstInvalidField.element.focus();
        }

        e.preventDefault();
        return false;
      }
    });
  }
}
